<template>
<div>
  <b-row style="margin-left: 10px">
    <b-col md="4">
      <label class="mt-2">Ta'mir turi</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <label class="mt-2">Iqtisoslashgan o'qitish turi</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <label class="mt-2">Joylashgan tuman</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <label class="mt-2">Tuman markazigacha bo'lgan masofa</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <b-form-input
          id="input-default"
          style="margin-top: 35px"
          placeholder="Websayt"></b-form-input>
      <b-form-input
          class="mt-2"
          id="input-default"
          style="margin-top: 5px"
          placeholder="Qurilish Materiali"></b-form-input>
      <label class="mt-1">{{$t('message.Land_area')}}</label>
      <b-form-spinbutton id="sb-inline" v-model="value" inline></b-form-spinbutton>
    </b-col>
    <b-col md="4">
      <br>
      <b-form-input
          class="mt-3"
          id="input-default"
          placeholder="STIR (INN)"></b-form-input>
      <label class="mt-2">Joylashuv hududi</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <label class="mt-2">Joylashgan mahalla</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <b-form-input
          id="input-default"
          style="margin-top: 35px"
          placeholder="Telefon"></b-form-input>
      <label class="mt-2">Faollar zali</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <b-form-input
          class="mt-2"
          id="input-default"
          style="margin-top: 5px"
          placeholder="Filiallari"></b-form-input>
      <label class="mt-1">{{$t('message.Grade_prognosis')}}</label>
      <b-form-spinbutton id="sb-inline" v-model="value" inline></b-form-spinbutton>
    </b-col>
    <b-col md="4">
      <label class="mt-2">Navbatligi</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <label class="mt-2">Joylashgan hudud</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <label class="mt-2">Kutubxona</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <label class="mt-2">Informatika shtatlar soni</label>
      <b-form-select
          v-model="selected"
          :options="options"
          class="form-select d-flex"
          aria-label="Default select example"></b-form-select>
      <b-form-input
          id="input-default"
          style="margin-top: 35px"
          placeholder="Yuridik manzili"></b-form-input>
      <b-form-input
          class="mt-2"
          id="input-default"
          style="margin-top: 5px"
          placeholder="Elektron pochta"></b-form-input>
    </b-col>
  </b-row>
</div>
</template>

<script>
export default {
  name: "SecondRow",
  data(){
    return{
      options: [
        { value: null, text: 'Please select an option' },
        { value: 'a', text: 'This is First option' },
        { value: 'b', text: 'Selected Option' },
        { value: { C: '3PO' }, text: 'This is an option with object value' },
      ],
    }
  }
}
</script>

<style scoped>

</style>
